import { Injectable } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';
import * as io from 'socket.io-client';

import { environment } from '../../environments/environment';

@Injectable()
export class HermesService {

  constructor() { }

  private socket;

  updates() {
    const observable = new Observable(observer => {
      this.socket = io(environment.socketBase);

      this.socket.on(`update:finishing-positions`, (data) => {
        data = JSON.parse(data);
        data.type = 'finishingPositions';
        observer.next(data);
      });

      this.socket.on(`update:non-finisher`, (data) => {
        data = JSON.parse(data);
        data.type = 'nonFinisher';
        observer.next(data);
      });

      this.socket.on(`update:non-runner`, (data) => {
        data = JSON.parse(data);
        data.type = 'nonRunner';
        observer.next(data);
      });

      this.socket.on(`update:entry-ground-conditions`, (data) => {
        data = JSON.parse(data);
        data.type = 'groundConditions';
        observer.next(data);
      });

      return () => {
        console.log('[ DEBUG ] Hermes Disconnected');
        this.socket.disconnect();
      };
    });
    return observable;
  }

}
